import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NewsletterComponent } from '@app/shared/components/newsletter/newsletter.component';

interface PrivacySection {
  id: string;
  number: string;
  title: string;
  icon: string;
}

@Component({
  selector: 'app-politica-privacidade',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, NewsletterComponent],
  templateUrl: './politica-privacidade.component.html',
  styleUrl: './politica-privacidade.component.scss',
})
export class PoliticaPrivacidadeComponent implements OnInit {
  private readonly scroller = inject(ViewportScroller);
  private readonly route = inject(ActivatedRoute);

  activeSectionId: string = 'seccao-1';
  dataActualizacao: string = '16 de Outubro de 2026';
  versaoDocumento: string = '1.0';
  copySuccess: boolean = false;

  sections: PrivacySection[] = [
    {
      id: 'seccao-1',
      number: '1',
      title: 'Âmbito e Aplicabilidade',
      icon: 'fa-solid fa-file-shield',
    },
    {
      id: 'seccao-2',
      number: '2',
      title: 'Dados Pessoais Tratados',
      icon: 'fa-solid fa-database',
    },
    {
      id: 'seccao-3',
      number: '3',
      title: 'Finalidades, Fundamentos e Prazos',
      icon: 'fa-solid fa-calendar-check',
    },
    {
      id: 'seccao-4',
      number: '4',
      title: 'Sistema de Pagamentos e Informação Pública',
      icon: 'fa-solid fa-credit-card',
    },
    {
      id: 'seccao-5',
      number: '5',
      title: 'Partilha de Dados com Terceiros',
      icon: 'fa-solid fa-handshake',
    },
    {
      id: 'seccao-6',
      number: '6',
      title: 'Cookies e Medidas de Segurança',
      icon: 'fa-solid fa-cookie-bite',
    },
    {
      id: 'seccao-7',
      number: '7',
      title: 'Direitos do Titular dos Dados',
      icon: 'fa-solid fa-user-check',
    },
    {
      id: 'seccao-8',
      number: '8',
      title: 'Protecção de Menores',
      icon: 'fa-solid fa-child-reaching',
    },
    {
      id: 'seccao-9',
      number: '9',
      title: 'Alterações a Esta Política',
      icon: 'fa-solid fa-clock-rotate-left',
    },
    {
      id: 'seccao-10',
      number: '10',
      title: 'Contactos e Encarregado de Dados (DPO)',
      icon: 'fa-solid fa-address-book',
    },
    {
      id: 'seccao-11',
      number: '11',
      title: 'Entrada em Vigor',
      icon: 'fa-solid fa-flag-checkered',
    },
  ];

  ngOnInit(): void {
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        setTimeout(() => {
          this.scrollTo(fragment);
        }, 150);
      }
    });
  }

  scrollTo(sectionId: string): void {
    this.activeSectionId = sectionId;
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -90; // offset do cabeçalho fixo
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  printDocument(): void {
    window.print();
  }

  copyLink(): void {
    if (typeof window !== 'undefined' && navigator.clipboard) {
      const url = window.location.href;
      navigator.clipboard.writeText(url).then(() => {
        this.copySuccess = true;
        setTimeout(() => {
          this.copySuccess = false;
        }, 2500);
      });
    }
  }
}
